import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PlanSelection from '../PlanSelection/PlanSelection';
import Inclusions from '../Inclusions/Inclusions';
import VehicleTow from '../Multiple/VehicleTow';
import ProceedButton from '../Multiple/ProceedButton';
import LocationTracker from '../LocationTracker';
import '../../styles/global.css';
import '../../styles/loader.css';
import './Body.css';
import {checkCustomer,setIsNewCustomer} from '../../store/reducers/profileReducer';
import { setOtpVerified } from '../../store/reducers/flowStepReducer';
import { useNavigate } from 'react-router-dom';
import { parseMobileParams, isEncrypted } from './../../utils/Common.js';

const defaultItems = [
  { icon: '/assets/inclusion/cab-assistance.svg', value: 'Cab Assistance' },
  { icon: '/assets/inclusion/emergency-accident.svg', value: 'Emergency Accident Towing Assistance' },
  { icon: '/assets/inclusion/key.svg', value: 'Car Key Repairs' },
  { icon: '/assets/inclusion/emergency-accident.svg', value: 'Emergency Car Breakdown Services' },
  { icon: '/assets/inclusion/house.svg', value: 'Accommodation' },
  { icon: '/assets/inclusion/tyre.svg', value: 'Flat Tyre Service' },
  { icon: '/assets/inclusion/fuel.svg', value: 'Emergency Fuel Delivery' },
  { icon: '/assets/inclusion/coverage.svg', value: 'Coverage Area Emergency' },
];

function Body() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const profileResponse = useSelector((state) => state.profileList);
  const profileData = profileResponse.profileData || {};

  console.log("profileResponseprofileResponse",profileResponse);
  const [vehicleType, setVehicleType] = useState(null);
  const [plan, setPlan] = useState(null);


  useEffect(() => {

  //if localStorage exist clear;
  console.log("Before clear localstorage:",JSON.parse(localStorage.getItem('customerProfile')));
    localStorage.removeItem('customerProfile');
    console.log("After clear localstorage:",JSON.parse(localStorage.getItem('customerProfile')));

    const parsed = parseMobileParams();
    // Get the URL parameters
    // const params = new URLSearchParams(window.location.search);
    // let mobileNumber = params.get('mobile');
    // let source = params.get('src');
    
    if (parsed) {
      console.log("parsed:", parsed);
      console.log("parsed mobileNumber :", parsed.mobileNumber);
      console.log("parsed source :", parsed.source);
      console.log("parsed verifiedData :", parsed.verifiedData);
      let verifiedData = parsed.verifiedData;
      let mobileNumber = parsed.mobileNumber;
        // mobileNumber = mobileNumber.replace(/ /g, '+'); // sometime encrypted mobile have plus charecter, due to this it getting space
        // console.log("After Corrected mobile number:", mobileNumber);
        // setMobileParam(mobileNumber);
        dispatch(setOtpVerified(true));
        localStorage.setItem('mblnbr', JSON.stringify(mobileNumber));
        // let verifiedData = isEncrypted(mobileNumber,source);
        // console.log("verifiedData",verifiedData);
        // dispatch(checkCustomer({mobile:mobileNumber,web:false}));
        dispatch(checkCustomer(verifiedData));
    } else {
      dispatch(setIsNewCustomer(true)); // manually mark as new customer
      console.log('Mobile number not found in Redux state');
    }

    if(profileData?.planExistCustomer){
      navigate('/my-plans');
    }

  }, []);

  return (
    <main className="body membership">
      <div className="section-one">
        <VehicleTow />
        {/* <LocationTracker /> */}
      </div>
      <PlanSelection onSelect={setVehicleType} />
      <Inclusions  vehicleType={vehicleType} />
      <ProceedButton />
    </main>
  );
}

export default Body;
